import styled from "styled-components";

export const ContainerRadio = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	.MuiRadio-colorSecondary.Mui-checked {
		color: ${({ theme }) => theme.pantone2726C};
	}

	.Mui-disabled {
		&:hover {
			cursor: not-allowed;
		}

		.MuiIconButton-label {
			background: ${({ theme }) => theme.disabled};
			padding: 0;
			border-radius: 50%;

			.MuiSvgIcon-root {
				margin: -2px;
				color: gray;
			}
		}
	}
`;
